import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.uuid,
      id: item.uuid,
      title: item.title,
      description: item.description,
      start_date: item.start_date,
      end_date: item.end_date,
      type: item.type,
      image_url: item.image_url,
      event_url: item.event_url,
      promo_code: item.promo_code,
      terms: item.terms,
      organization: item.organization,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getPromotions({ payload: { signal, searchQ, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.promotions.list,
      params: { page: curr_page, q: searchQ },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getPromotionsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getPromotionsFailed,
      endpoint: api.promotions.list.url
    });
  }
}

export const getPromotionsSaga = takeEvery(types.GET_PROMOTIONS_REQUEST, getPromotions);